import {RemoteCollectionStore, StoreBuilder} from '@softline/core';
import {Firma} from './vkforg-context/data/firma';

export const FirmaStore = new StoreBuilder(RemoteCollectionStore.create<Firma>()).value;
